import React from 'react'
import { CCol, CRow } from '@coreui/react-pro'
import { FormData } from './types'

type Props = {
  initialData: FormData
}

export const InitialValuesForm: React.FC<Props> = ({ initialData }) => {
  return (
    <>
      <CRow>
        <CCol>Initial Amount:</CCol>
        <CCol>
          <p>
            {initialData.initialAmount} {initialData.initialCurrency}
          </p>
        </CCol>
      </CRow>
      <CRow>
        <CCol>Client Amount:</CCol>
        <CCol>
          <p>
            {initialData.clientAmount} {initialData.clientCurrency}
          </p>
        </CCol>
      </CRow>
      <CRow>
        <CCol>Exchange Rate:</CCol>
        <CCol>
          <p>{initialData.exchangeRate}</p>
        </CCol>
      </CRow>
      <CRow>
        <CCol>Company Amount:</CCol>
        <CCol>
          <p>
            {initialData.companyAmount} {initialData.companyCurrency}
          </p>
        </CCol>
      </CRow>
      <CRow>
        <CCol>Company Commission:</CCol>
        <CCol>
          <p>{initialData.companyCommission}</p>
        </CCol>
      </CRow>
      <CRow>
        <CCol>Client Commission:</CCol>
        <CCol>
          <p>{initialData.clientCommission}</p>
        </CCol>
      </CRow>
      <CRow>
        <CCol>Inner Commission:</CCol>
        <CCol>
          <p>{initialData.innerCommission}</p>
        </CCol>
      </CRow>
      <CRow>
        <CCol>Initial Amount usd:</CCol>
        <CCol>
          <p>{initialData.initialAmountUsd}</p>
        </CCol>
      </CRow>
    </>
  )
}
